<template>
  <aha-modal
    @mouseup.stop
    v-if="visibleModalImport"
    :title="title_Import"
    @hide="hide()"
    classes="mb-6"
  >
    <div class="pb-4">
      {{ $i18nPresenter.t("Upload a PDF, PPT or PPTX file. Up to 50MB and 100 slides.") }}
    </div>

    <div class="tab-content">
      <label
        for="upload-file"
        class="text-center"
      >
        <div v-if="$store.state.importStatus == 1">
          <div
            class="px-3 text-red-100 error-text"
            v-if="$store.state.importError"
            v-html="$store.state.importError"
          />

          <div>
            <aha-icon
              name="cloud-import"
              width="50"
              height="50"
              viewBox="0 0 55 40"
              class="text-primary-80"
            />
            <div class="py-2">
              <p class="pb-1">{{ $i18nPresenter.t("Drag and drop here") }}</p>
              <p>{{ $i18nPresenter.t("or") }}</p>
            </div>
          </div>
        </div>

        <div
          v-if="$store.state.importStatus == 2 || $store.state.importStatus == 3"
          class="text-center"
        >
          <p class="text-lg font-bold" v-if="$store.state.importStatus == 2">{{ $i18nPresenter.t("Uploading...") }}</p>
          <p class="text-lg font-bold" v-if="$store.state.importStatus == 3">{{ $i18nPresenter.t("Converting...") }}</p>

          <div class="pt-2">
            {{ $i18nPresenter.t("Large presentations may take several minutes to finish.") }}
            <br>{{ $i18nPresenter.t("The imported slides will be added to the end of your presentation.") }}
          </div>
          <div>
            <div class="py-2">
              <aha-spinner
                variant="dark"
              />
            </div>
            <aha-button @click="hide()">
              {{ $i18nPresenter.t("Close this window") }}
            </aha-button>
            <div class="pt-2">{{ $i18nPresenter.t("The import will continue in the background.") }}</div>
          </div>
        </div>

        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept=".ppt, .pptx, .pdf"
          id="upload-file"
          v-if="$store.state.importStatus == 1"
          drop-placeholder="drop image"
          :file-name-formatter="uploadFile"
          @mouseup.stop
        />
      </label>
      <aha-button v-if="$store.state.importStatus === 1" @click="clickBrowseFile">
        {{ $i18nPresenter.t("Browse File...") }}
        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept=".ppt, .pptx, .pdf"
          id="upload-file"
          v-if="$store.state.importStatus == 1"
          drop-placeholder="drop image"
          :file-name-formatter="uploadFile"
          @mouseup.stop
        />
      </aha-button>
    </div>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import Config from '@/config'
import Socket from '@/socket'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    screen: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      file: null,
      uploadDone: false,
      visibleModalImport: false,
      title_Import: this.$i18nPresenter.t('Import from a presentation on your computer'),
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      selectedFolderId: (state) => state.selections.selectedFolderId,
      isOnboardingV3Showing: (state) => state.indicators.isOnboardingV3Showing,
    }),
    gaCategory() {
      if (this.$route.path === '/apps/presentations' || this.isOnboardingV3Showing) {
        return eventCategories.PRESENTATION_LIST
      }
      return eventCategories.PRESENTATION_EDITOR
    },
    eventLabel() {
      return this.isOnboardingV3Showing ? 'Import from onboarding' : ''
    },
    eventValue() {
      return this.isOnboardingV3Showing ? 'Onboarding option' : ''
    },
    isTestUploadV2() {
      return true
      // if (Config.env === 'local') return true
      // return this.currentUser && this.currentUser.email &&
      //   (this.currentUser.email.includes('@a.com') ||
      //   this.currentUser.email.includes('@ahaslides.com'))
    },
  },
  mounted() {
    this.show()
  },
  methods: {
    clickBrowseFile() {
      return Utils.mixpanelTracking(this.gaCategory, 'Import > Browse file', this.eventLabel, this.eventValue)
    },
    uploadFile(files) {
      if (!files || !files.length) return
      const file = files[0]
      this.$store.state.importError = ''
      if (file && file.size > 52428800) {
        this.$store.state.importError =
          '<div>Maximum file size is 50 MB. Maximum slide amount is 100 slides. <br /> Please try again with a smaller file.</div>'
        Utils.mixpanelTracking(this.gaCategory, 'Import > Upload file', this.eventLabel, `${this.eventValue}${this.eventValue ? ' > ' : ''}'Exceed 50MB'`)
        return
      }

      const ext = file.name.split('.').pop()
      if (ext.indexOf('ppt') === -1 && ext.indexOf('pdf') === -1) {
        this.$store.state.importError =
          'Could not upload this file (only support file pptx, ppt, pdf).'
        Utils.mixpanelTracking(this.gaCategory, 'Import > Upload file', this.eventLabel, `${this.eventValue}${this.eventValue ? ' > ' : ''}'Invalid file type'`)
        return
      }

      this.$store.state.importStatus = 2
      Utils.mixpanelTracking(this.gaCategory, 'Import > Processing', this.eventLabel, `File size: ${file.size}`)
      const formData = new FormData()
      formData.append('file', file)
      formData.append(
        'accessCode',
        this.$store.state.presentation.uniqueAccessCode,
      )
      formData.append('socketId', Socket.getSocketId())
      formData.append('type', this.type)
      formData.append('fileSize', file.size)
      formData.append('fileName', file.name)
      if (this.selectedFolderId) {
        formData.append('folderId', this.selectedFolderId)
      }
      if (!this.screen && this.$store.state.presentation.id) {
        formData.append('presentationId', this.$store.state.presentation.id)
      }
      const headers = new Headers()
      headers.append('Content-Type', 'application/x-www-form-urlencoded')
      // Upload presentation logo
      const url = this.isTestUploadV2 ? Config.workerApi.uploadFileDocumentV2 : Config.workerApi.uploadFileDocument
      this.$http.post(url, formData).then(
        () => {
          this.$store.state.importStatus = 3
        },
        () => {
        },
      )
    },
    show() {
      this.uploadDone = false
      this.visibleModalImport = true
    },
    hide() {
      this.$store.state.importError = null
      this.$store.state.openImportModal = false
      Utils.mixpanelTracking(this.gaCategory, 'Import > Close modal', this.eventLabel, this.eventValue)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.tab-content {
  @apply border-2 border-dashed border-primary-90 px-4;
  @apply bg-primary-60 rounded py-8;
  @apply relative text-center;
}
.custom-file {
  @apply absolute inset-0 overflow-hidden opacity-0;
  & ::v-deep .custom-file-input {
    @apply w-full  h-full cursor-pointer;
  }
}

</style>
